// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorFreightBookings = (client) => ({
    /**
     * `GET /vendor/freight-bookings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListFreightBookings
     * @source packages/medusa-plugin-searates-v2/src/api/vendor/freight-bookings/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/freight-bookings", { method: "GET", query, headers }),
    /**
     * `GET /vendor/freight-bookings/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetFreightBooking
     * @source packages/medusa-plugin-searates-v2/src/api/vendor/freight-bookings/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/freight-bookings/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/freight-bookings/:id/track`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorTrackFreightBooking
     * @source packages/medusa-plugin-searates-v2/src/api/vendor/freight-bookings/[id]/track/route.ts
     */
    retrieveTrack: (id, query, headers) => client.fetch(buildPath("/vendor/freight-bookings/:id/track", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=freight-bookings.js.map